var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStep3ChoosePlanActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E3F444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.38 53.97C18.36 53.91 18.35 53.84 18.33 53.78L14.02 34.54C13.42 31.88 15.1 29.25 17.75 28.65L51.8 21.02C54.46 20.42 57.09 22.1 57.69 24.75L58.24 27.2",
    stroke: "#2C2C2C",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6401 30.3599H25.7401C23.0173 30.3599 20.8101 32.5671 20.8101 35.2899V55.0099C20.8101 57.7326 23.0173 59.9399 25.7401 59.9399H60.6401C63.3628 59.9399 65.5701 57.7326 65.5701 55.0099V35.2899C65.5701 32.5671 63.3628 30.3599 60.6401 30.3599Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.76 37.1299H65.32",
    stroke: "#2C2C2C",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4499 51.5601C33.6699 52.3001 32.6399 52.7401 31.4899 52.7401C29.0999 52.7401 27.1699 50.8101 27.1699 48.4201C27.1699 46.0301 29.0999 44.1001 31.4899 44.1001C32.6399 44.1001 33.6799 44.5501 34.4499 45.2801",
    stroke: "#2C2C2C",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4001 52.7298C39.7859 52.7298 41.7201 50.7957 41.7201 48.4098C41.7201 46.024 39.7859 44.0898 37.4001 44.0898C35.0142 44.0898 33.0801 46.024 33.0801 48.4098C33.0801 50.7957 35.0142 52.7298 37.4001 52.7298Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.46,
    height: 40.84,
    fill: "white",
    transform: "translate(13 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep3ChoosePlanActive);
export default __webpack_public_path__ + "static/media/icon_step3_choose_plan_active.af0e068178cde55a351f23accfc3c2c0.svg";
export { ForwardRef as ReactComponent };